import React from 'react';

import { SVGComponentProps } from './svg.types';

const AssignTaskSVG = ({ size = '1em', ...otherSvgProps }: SVGComponentProps) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect x="0.5" y="0.5" width="17" height="19" rx="1.5" fill="#F9FAFB" />
      <path
        d="M10.6845 12.1094C10.4519 12.1094 10.2634 12.3084 10.2634 12.5539V14.6842L12.7026 12.1095L10.6845 12.1094Z"
        fill="#9BADEE"
      />
      <path
        d="M9.63108 5.66667C9.63108 6.03482 9.34827 6.33334 8.9995 6.33334C8.65072 6.33334 8.36792 6.03482 8.36792 5.66667C8.36792 5.29852 8.65072 5 8.9995 5C9.34827 5 9.63108 5.29852 9.63108 5.66667Z"
        fill="#9BADEE"
      />
      <path
        d="M5 6.33412V14.5565C5 14.8019 5.18855 15.0009 5.42109 15.0009H9.84208V12.5565C9.84208 12.0656 10.2191 11.6676 10.6841 11.6676H13V6.33419C13 6.08872 12.8114 5.88977 12.5789 5.88977H10.0317C9.93203 6.40764 9.50071 6.77974 9.00011 6.77974C8.49951 6.77974 8.06818 6.40764 7.96852 5.88977H5.42131C5.18877 5.88977 5.00022 6.08872 5.00022 6.33419L5 6.33412ZM6.05266 7.44521H7.52628C7.64258 7.44521 7.73682 7.54476 7.73682 7.66746C7.73682 7.79015 7.64258 7.88971 7.52628 7.88971H6.05266C5.93636 7.88971 5.84212 7.79015 5.84212 7.66746C5.84212 7.54476 5.93636 7.44521 6.05266 7.44521ZM6.05266 8.55638H11.3156C11.4319 8.55638 11.5262 8.65586 11.5262 8.77855C11.5262 8.90132 11.4319 9.0008 11.3156 9.0008H6.05266C5.93636 9.0008 5.84212 8.90132 5.84212 8.77855C5.84212 8.65586 5.93636 8.55638 6.05266 8.55638ZM6.05266 9.66747H11.3156C11.4319 9.66747 11.5262 9.76695 11.5262 9.88972C11.5262 10.0124 11.4319 10.1119 11.3156 10.1119H6.05266C5.93636 10.1119 5.84212 10.0124 5.84212 9.88972C5.84212 9.76695 5.93636 9.66747 6.05266 9.66747ZM6.05266 10.7786H11.3156C11.4319 10.7786 11.5262 10.8781 11.5262 11.0008C11.5262 11.1235 11.4319 11.2231 11.3156 11.2231H6.05266C5.93636 11.2231 5.84212 11.1235 5.84212 11.0008C5.84212 10.8781 5.93636 10.7786 6.05266 10.7786ZM6.05266 12.7786H6.89471C7.01101 12.7786 7.10526 12.8781 7.10526 13.0008C7.10526 13.1235 7.01101 13.2231 6.89471 13.2231H6.05266C5.93636 13.2231 5.84212 13.1235 5.84212 13.0008C5.84212 12.8781 5.93636 12.7786 6.05266 12.7786Z"
        fill="#9BADEE"
      />
      <rect x="0.5" y="0.5" width="17" height="19" rx="1.5" stroke="#F6F7F9" />
    </svg>
  );
};

export default AssignTaskSVG;
